import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholder Analysis Details',
      type: 'details',
      alias: 'details.stakeholder.modal',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.stakeholder',
            },
          },
        ],
      },
      content: {
        '{}': {
          sections: {
            '@': 'stakeholderSections',
          },
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              name: 'Edit',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'edit.stakeholder.modal',
                        },
                      },
                      variables: {
                        '{}': {
                          stakeholderId: {
                            '@$': 'stakeholderId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    stakeholderId: '?stakeholder-alexis-bennett',
  },
  subqueries: {
    stakeholderSections: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'stakeholderId',
          },
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              name: 'Stakeholder Overview',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderName',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder Name',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'jobTitleRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Job Title / Role',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'jobTitle',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'departmentFunction',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Department / Function',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'department',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'subdepartmentTeam',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Subdepartment / Team',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'subdepartment',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'managerLeader',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Manager / Leader',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'manager',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 3,
            },
          },
          {
            '{}': {
              name: 'Project Involvement',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'projectTeam',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Team',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!is_project_team_member',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'projectRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_project_role',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!project_role',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'systemUserRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'System / User Role',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!system_user_role',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 3,
            },
          },
          {
            '{}': {
              name: 'Impact and Influence',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'degreeOfImpact',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Degree of Impact',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!degree_of_impact',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'influenceDecisionRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Influence / Decision Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!influence_decision_role',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'changeChampion',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Change Champion',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_change_champion',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!change_champion',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'engagementNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Engagement Needed',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_engagement_needed',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!engagement_needed',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 4,
            },
          },
          {
            '{}': {
              name: 'Validation Status',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'validationStatus',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Validation Status',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_validation_status',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!validation_status',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Understanding',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'understanding',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Understanding',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!understanding',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Perceived Attitude',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'perceivedAttitude',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Perceived Attitude',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_perceived_attitude',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!perceived_attitude',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Potential Concerns and Risks',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'potentialConcernsRisks',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Potential Concerns / Risks',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!concerns_risks',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Support Needs',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'supportNeeds',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Support Needs',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!support_needs',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
          {
            '{}': {
              name: 'Communications and Training',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'communicationAudience',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communication Audience / Group',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!comm_audience',
                      },
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'trainingAudienceNeed',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Audience / Need',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_training_audience',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_audience_need',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 2,
            },
          },
          {
            '{}': {
              name: 'Notes and Follow-Up',
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'notesFollowUp',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Notes / Follow-Up',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!notes_follow_up',
                      },
                      readonly: true,
                    },
                  },
                ],
              },
              columnCount: 1,
            },
          },
        ],
      },
      subqueries: {
        manager: {
          ref: {
            attr: 'attr:ent#!personnel_leaders#!relationship:!leader',
          },
          using: 'managerRelationship',
          target: 'ent:!personnel:!employee',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        employee: {
          ref: {
            attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
          },
          target: 'ent:!personnel:!employee',
        },
        jobTitle: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!job_title',
          },
          using: 'employee',
          target: 'ent:!job_titles:!job_title',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        department: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!org',
          },
          using: 'employee',
          target: 'ent:!org:!subdept',
          quantity: 1,
          selection: {
            if: [
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-advancement',
                  ],
                },
                'Advancement',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-athletics',
                  ],
                },
                'Athletics',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-finance-and-treasury',
                  ],
                },
                'Finance and Treasury',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-information-technology',
                  ],
                },
                'Information Technology',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-undergraduate-financial-aid',
                  ],
                },
                'Undergraduate Financial Aid',
              ],
              [
                {
                  '=': [
                    {
                      '@^': 'parent',
                    },
                    '?dept-school-of-engineering-and-applied-science',
                  ],
                },
                'School of Engineering and Applied Science',
              ],
              null,
            ],
          },
        },
        subdepartment: {
          ref: {
            attr: 'attr:ent#!personnel#!employee:!org',
          },
          using: 'employee',
          target: 'ent:!org:!subdept',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        managerRelationship: {
          ref: {
            attr: 'attr:ent#!personnel_leaders#!relationship:!personnel',
          },
          using: 'employee',
          target: 'ent:!personnel_leaders:!relationship',
        },
      },
    },
  },
}
